require.register("documenteditor/documenteditor", function(exports, require, module){
  $0
  
});

